<template>
  <parts @remove="$emit('remove')" :cols="2" title="クリア">
    <td>
      <b-form-select v-model="form.layer"
        :options="[
          { value:'front3', text:'紹介/テロップ' },
          { value:'bg2', text:'背景' },
          { value:'bg3', text:'効果' },
        ]" 
      />
    </td>
  </parts>
</template>

<script>
import parts from './parts'
export default {
  props:{
    options: Object
  },
  components:{
    parts
  },
  data () {
    return {
      form: {
        layer: this.options.layer,
      },
    }
  },
  watch: {
    'form.layer': function(){
      this.$emit('input', this.form)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
